import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import AddEligibility from "./addEligibility";
import EligibilityTable from "./eligibilityTable";

export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

 

  return (
    <Grid
      p={page === "eligibilitycriteria" ? "none" : 3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
          page === "eligibilitycriteria"  ? "none" : "#fff",
        borderRadius: "8px",
      }}
    >
      {page === "eligibilitycriteria" && (
        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end",py:1 }}
          >
            <MauvelousPrimaryButton
              title={"Add Eligibility"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/eligibility-management?page=addeligibility`
                )
              }
            />
          </Grid>
          <Grid item md={12}>
            <EligibilityTable />
          </Grid>
        </Grid>
      )}
      {page === "addeligibility" && <AddEligibility />}
      {page === "updateeligibility" && <AddEligibility />}
    </Grid>
  );
}
